import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { 
  UserOutlined, 
  CheckCircleOutlined, 
  ClockCircleOutlined,
  StopOutlined,
  UserAddOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';

const UserStats = ({ users = [], loading }) => {
  // Calculer les statistiques à partir de la liste des utilisateurs
  const calculateStats = (usersList) => {
    if (!usersList || usersList.length === 0) {
      return { 
        total: 0, 
        active: 0, 
        pending: 0, 
        suspended: 0,
        notVerified: 0,  // Non vérifiés (KYC)
        newToday: 0      // Nouveaux aujourd'hui (exemple)
      };
    }
    
    const today = new Date().toDateString();
    
    return {
      total: usersList.length,
      // Statut du compte
      active: usersList.filter(u => u.account_status === 'active').length,
      pending: usersList.filter(u => u.account_status === 'pending').length,
      suspended: usersList.filter(u => 
        ['suspended', 'banned'].includes(u.account_status)
      ).length,
      // Statut de vérification KYC
      notVerified: usersList.filter(u => 
        ['pending', 'unverified', null, undefined].includes(u.kyc_status)
      ).length,
      // Autres métriques
      newToday: usersList.filter(u => {
        const userDate = new Date(u.created_at).toDateString();
        return userDate === today;
      }).length
    };
  };

  const { total, active, pending, suspended, notVerified, newToday } = calculateStats(users);

  return (
    <div style={{ marginBottom: '32px' }}>
      <Row gutter={[20, 20]}>
        {[
          { title: "Total Utilisateurs", value: total, icon: <UserOutlined />, color: "blue" },
          { title: "Actifs", value: active, icon: <CheckCircleOutlined />, color: "green" },
          { title: "En attente", value: pending, icon: <ClockCircleOutlined />, color: "orange" },
          { title: "Suspendus", value: suspended, icon: <StopOutlined />, color: "red" },
          { title: "Non vérifiés (KYC)", value: notVerified, icon: <ExclamationCircleOutlined />, color: "purple" },
          { title: "Nouveaux aujourd'hui", value: newToday, icon: <UserAddOutlined />, color: "blue" },
          { title: "Taux d'activation", value: total > 0 ? ((active / total) * 100).toFixed(1) : 0, suffix: "%", color: "green" },
          { title: "Taux de suspension", value: total > 0 ? ((suspended / total) * 100).toFixed(1) : 0, suffix: "%", color: "red" }
        ].map((item, idx) => (
          <Col key={idx} xs={24} sm={12} md={6} lg={6}>
            <Card loading={loading} className="glass-card stat-card-compact">
              <div className="flex items-center gap-4">
                <div className={`p-3 rounded-xl bg-${item.color}-500/10 border border-${item.color}-500/20`}>
                  {item.icon ? React.cloneElement(item.icon, { className: `text-${item.color}-400 text-xl` }) : null}
                </div>
                <div>
                  <div className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1">{item.title}</div>
                  <div className={`text-2xl font-black text-${item.color}-400`}>
                    {item.value}{item.suffix || ''}
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      
      <style dangerouslySetInnerHTML={{ __html: `
        .stat-card-compact { padding: 16px !important; }
        .stat-card-compact .ant-card-body { padding: 0 !important; }
        .text-blue-400 { color: #60a5fa; } .bg-blue-500\\/10 { background: rgba(59, 130, 246, 0.1); } .border-blue-500\\/20 { border-color: rgba(59, 130, 246, 0.2); }
        .text-green-400 { color: #4ade80; } .bg-green-500\\/10 { background: rgba(34, 197, 94, 0.1); } .border-green-500\\/20 { border-color: rgba(34, 197, 94, 0.2); }
        .text-orange-400 { color: #fb923c; } .bg-orange-500\\/10 { background: rgba(249, 115, 22, 0.1); } .border-orange-500\\/20 { border-color: rgba(249, 115, 22, 0.2); }
        .text-red-400 { color: #f87171; } .bg-red-500\\/10 { background: rgba(239, 68, 68, 0.1); } .border-red-500\\/20 { border-color: rgba(239, 68, 68, 0.2); }
        .text-purple-400 { color: #c084fc; } .bg-purple-500\\/10 { background: rgba(168, 85, 247, 0.1); } .border-purple-500\\/20 { border-color: rgba(168, 85, 247, 0.2); }
      `}} />
    </div>
  );
};

export default UserStats;